export default __webpack_public_path__ + "static/topNavItems-do-2-light-24cb6e8283ed6266a9c7a889463c0593.png";